var _path, _path2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationIconSoftLaunch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-soft-launch-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.76,2.81a1.5,1.5,0,0,0-.44-1.13,1.46,1.46,0,0,0-1.14-.44c-1.75.1-6.08.59-8.59,3.1L9.46,7.46c-1.22-1.22-4.3-.76-8.19,3.13A1,1,0,0,0,2,12.29c.85,0,1.42,0,1.83,0l.52,0,.18.18-1,1,7.08,7.08,1-1,.18.18c0,.11,0,.32,0,.52,0,.41,0,1,0,1.83a1,1,0,0,0,.61.92.91.91,0,0,0,.39.08,1,1,0,0,0,.7-.29c3.89-3.89,4.35-7,3.13-8.19l3.12-3.13C22.17,8.9,22.66,4.57,22.76,2.81ZM4.68,10.26C6.61,8.84,7.77,8.8,8,8.89L5.93,11A2,2,0,0,0,4.68,10.26Zm9.06,9.06A2,2,0,0,0,13,18.07L15.11,16C15.2,16.23,15.16,17.39,13.74,19.32Zm-3.15-1.66L6.34,13.41,14,5.76c1.82-1.82,5.12-2.34,6.72-2.48-.14,1.6-.66,4.9-2.48,6.72Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.12,5.88a2,2,0,0,0-1.41.58,2,2,0,1,0,1.41-.58Z",
    fill: "#343434"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.72,
    y: 18.57,
    width: 5.41,
    height: 2,
    transform: "translate(-12.54 8.86) rotate(-45)",
    fill: "#343434"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.66,
    y: 15.6,
    width: 3,
    height: 2,
    transform: "translate(-10.81 7.1) rotate(-45)",
    fill: "#343434"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 19.84,
    width: 3,
    height: 2,
    transform: "translate(-12.57 11.34) rotate(-45)",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconSoftLaunch);
export default __webpack_public_path__ + "static/media/navigation-icon-soft-launch.36f6b3f2ce6c51204133cb9d1cba7a5f.svg";
export { ForwardRef as ReactComponent };